import * as React from "react";
// import { pure } from 'recompose'
import ButtonGrid from "@tunnel-components/@sharded/widgets/forms/input/button/custom/component";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    title,
    onClose,
    sequence,
    onSequence,
    onSubmit,
    BtnTextSpan,
    error /*required*/,
  } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */

  return (
    <div className="cart-box-incidents boxIn ">
      <div className="cart-incident">
        <div className="box-header-custom">
          <div className="box-center-display">
            <div className="left part-left">
              {title && <span className="box-title">{title}</span>}
            </div>
            <div className="left part-right">
              {onClose && (
                <span className="box-close" onClick={onClose}>
                  <span className="lacroix" />
                </span>
              )}
              {sequence && (
                <span className="box-sequence-encours" onClick={onSequence} />
              )}
            </div>
          </div>
        </div>
        <div className="midlle-box">{props.children}</div>
        {BtnTextSpan && (
          <div className="bottom-bo">
            <ButtonGrid onSubmit={onSubmit} error={error} text={BtnTextSpan} />
          </div>
        )}
      </div>
    </div>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  children?: any;
  title?: any;
  onClose?: any;
  sequence?: any;
  onSequence?: any;
  onSubmit?: any;
  BtnTextSpan?: any;
  error?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/box/custom/component.tsx